import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Typography} from 'views/components';
import {CheckCircle} from 'views/icons';
import {MarkdownViewer, Translate} from 'views/module';

const CustomDescriptionSection = (props) => {
  const {
    customDescription,
    questions,
  } = props;

  const firstName = questions.firstName;

  if (!customDescription) return null;

  return (
    <Box
      sx={{
        bgcolor: 'transparent',
        background: 'linear-gradient(90deg, #f0fcf3 0%, #eff6fe 100%)',
        borderRadius: 4,
        p: 3,
        width: '100%',
        boxSizing: 'border-box',
        mb: 2,
      }}
    >
      <Stack direction="row" alignItems="flex-start" spacing={1}>
        <CheckCircle sx={{color: 'success.main', fontSize: 28}} />
        <Stack alignItems="flex-start" spacing={0.5}>
          <Typography variant="subtitle1" fontWeight="bold">
            <Translate
              expression="caregiverProfile.CustomDescription.Title"
              substitute={{firstName: firstName}}
            />
          </Typography>
          <MarkdownViewer value={customDescription}/>
        </Stack>
      </Stack>
    </Box>
  );
};

CustomDescriptionSection.propTypes = {
  customDescription: PropTypes.string,
  questions: PropTypes.object.isRequired,
};

export default CustomDescriptionSection;
